module.exports = __webpack_public_path__ + "img/white07_128.fe8ffce8.png";